"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// import vjf from 'mobx-react-form/src/validators/VJF';
// import dvr from 'mobx-react-form/src/validators/DVR';
// import vjf from 'mobx-react-form/lib/validators/VJF';
// import dvr from 'mobx-react-form/lib/validators/DVR';
const VJF_1 = __importDefault(require("../../modules/mobx-react-form/src/validators/VJF"));
const DVR_1 = __importDefault(require("../../modules/mobx-react-form/src/validators/DVR"));
const validatorjs_1 = __importDefault(require("validatorjs"));
// import MobxReactForm from 'mobx-react-form';
const src_1 = __importDefault(require("../../modules/mobx-react-form/src")); // load from source (MASTER)
// import MobxReactForm from '../../modules/mobx-react-form/lib'; // load from build (MASTER)
const __hooks_form_1 = __importDefault(require("./_.hooks.form"));
const __bindings_1 = __importDefault(require("./_.bindings"));
const dvr_1 = __importDefault(require("./extension/dvr"));
// import svkExtend from './extension/svk';
class Form extends src_1.default {
    bindings() {
        return __bindings_1.default;
    }
    hooks() {
        return __hooks_form_1.default;
    }
    plugins() {
        return {
            vjf: (0, VJF_1.default)(),
            dvr: (0, DVR_1.default)({
                package: validatorjs_1.default,
                extend: dvr_1.default,
            }),
        };
    }
    options() {
        return {
            defaultGenericError: 'Invalid Data',
            autoParseNumbers: true,
        };
    }
}
exports.default = Form;
